import { render, staticRenderFns } from "./PedidoTable.vue?vue&type=template&id=dbc51638&scoped=true"
import script from "./PedidoTable.vue?vue&type=script&lang=js"
export * from "./PedidoTable.vue?vue&type=script&lang=js"
import style0 from "./PedidoTable.vue?vue&type=style&index=0&id=dbc51638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc51638",
  null
  
)

export default component.exports